import { IDesignStudio } from '@/components/organisms/or-design-studio-block/or-design-studio-block.types';
//import { IHousePlanHit } from '@/lib/search/types';

export const mlMapCardMockData = [];

export const mockStudioData = {
  Address: '779 White Pond Drive',
  City: 'Akron',
  Id: 1,
  IsDigital: false,
  Name: 'Akron-Canton',
  State: 'OH',
  States: [
    {
      Counties: [
        {
          Id: 437,
          Name: 'Carroll',
          IsPreferred: false,
        },
        {
          Id: 438,
          Name: 'Cuyahoga',
          IsPreferred: false,
        },
        {
          Id: 442,
          Name: 'Lorain',
          IsPreferred: false,
        },
        {
          Id: 443,
          Name: 'Medina',
          IsPreferred: false,
        },
        {
          Id: 446,
          Name: 'Stark',
          IsPreferred: false,
        },
        {
          Id: 447,
          Name: 'Summit',
          IsPreferred: false,
        },
        {
          Id: 448,
          Name: 'Tuscarawas',
          IsPreferred: false,
        },
      ],
      Id: 36,
      Name: 'OH',
    },
  ],
  Zip: '44320',
  IsVirtual: false,
  supports3D: true,
  hours: [
    {
      dates: {
        days: 'Mon',
        _metadata: {
          uid: 'csfdbbf37daee0b590',
        },
        hours: '9am - 6pm',
      },
    },
    {
      dates: {
        days: 'Tue',
        _metadata: {
          uid: 'cs6ab7b83259e13cd0',
        },
        hours: '10am - 8pm',
      },
    },
    {
      dates: {
        days: 'Wed',
        _metadata: {
          uid: 'csb4762f8f5e3e1106',
        },
        hours: '9am - 6pm',
      },
    },
    {
      dates: {
        days: 'Thu',
        _metadata: {
          uid: 'cs0f9917cf3891ac21',
        },
        hours: '10am - 8pm',
      },
    },
    {
      dates: {
        days: 'Fri',
        _metadata: {
          uid: 'cs59ba4609972fbe40',
        },
        hours: '9am - 6pm',
      },
    },
    {
      dates: {
        days: 'Sat',
        _metadata: {
          uid: 'cs2a5bb8a73ef5c4d5',
        },
        hours: '10am - 5pm',
      },
    },
    {
      dates: {
        days: 'Sun',
        _metadata: {
          uid: 'cs1253b4858aa8f7a1',
        },
        hours: 'Closed',
      },
    },
  ],
  lat: 41.0957656,
  long: -81.5901756,
  pageUrl: '/where-we-build/cleveland-akron',
  CsAddress: '779 White Pond Drive',
  CsName: 'Cleveland - Akron',
  CsCity: 'Akron',
  CsZip: '44320',
  CsState: 'OH',
  directionsLink: 'https://maps.app.goo.gl/6Ks14nMCWt4uTRay7',
  CsPhoneNumber: '(330) 865 4663',
  is_virtual: false,
} as IDesignStudio;
